import _environment from "../_environment/_environment";
import moment from "moment";

/**
 * Define if fair is started
 * @function
 */
export const isFairStarted = (): boolean => {
  return moment().isSameOrAfter(_environment.fairStartdate);
};

/**
 * Define if fair is over
 * @function
 */
export const isFairOver = (): boolean => {
  return moment().isAfter(_environment.fairEndDate);
};

/**
 * Define if fair is still taking place
 * @function
 */
export const isFairStillTakingPlace = (): boolean => {
  return isFairStarted() && !isFairOver();
};

/**
 * Slugify text
 * @function
 *
 * @param text
 */
export const slugify = (text: string) => {
  return text
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
};